import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreClass } from '@src/app/core/base/core.class';
import { COMMON_MODULES, IMAGES_URL } from '@src/app/core/constants';

@Component({
  selector: 'app-search-input',
  standalone: true,
  imports: [...COMMON_MODULES, ReactiveFormsModule],
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.scss'
})
export class SearchInputComponent extends CoreClass implements OnInit {
  search: string = '';
  zipCode: string = '';
  notFoundKeyword: string = '';
  
  IMAGES_URL: string = IMAGES_URL
  @Input() maxWidth: string = 'max-width : 635px'
  @Input() placeholder: string | null = ''
  @Input() keywordplaceholder: string | null = ''
  @Input() displayKeywordInput: boolean = true
  @Input() btnText: string | null = ''
  @Input() heading: string | null = ''
  @Input() subHeading: string | null = ''
  @Input() medicine: string | null = ''
  @Input() search1: string | null = ''
  @Input() search2: string | null = ''
  @Input() search3: string | null = ''
  @Input() errorMessage: string | null = ''
  @Input() errorSuggestion: string | null = ''
  @Input() noData: Boolean = false
  @Input() isLoading: Boolean = false
  @Output() searchResults = new EventEmitter<any>()
  @Output() searchAction: EventEmitter<any> = new EventEmitter();
  @Output() searchChange = new EventEmitter<any>()
  @Output() zipCodeChange = new EventEmitter<any>()
  debounceTimeout: any;
  @Input() screen = '';
  @Input() showSearchIconLeft: boolean = true;
  @Input() showSearchIconRight: boolean = true;
  @Input() showSearchText: boolean = true;
  @Input() zipCodePlaceholder = "Zip Code"
  @Input() backgroundColor = "#EFEFEF"
  @Input() locationIcon = 'icons/location-vector.svg'
  // When true, projected results (e.g. the zip/location dropdown) also render
  // while searching by zip code, not only while a keyword has been typed.
  @Input() showResultsOnZip: boolean = false
  onSearch() {
    if (this.screen == 'dental') {
      this.searchAction.emit({ title: this.sharedService.pharmacyInput, zipcode: this.sharedService?.pharmacyInfo?.zipCode });
    } else {
      this.searchAction.emit(this.search);
    }
  }

  ngOnInit(): void {
    console.log(this.sharedService.pharmacyInfo.zipCode);
    setTimeout(() => {
      console.log(this.sharedService.pharmacyInfo.zipCode);
    }, 5000);
    
  }

  onNumberInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '').slice(0, 5);
  }



  searchInput(event: any) {
    const value = event.target.value;

    // Clear previous timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.search = value;

    if (this.search == ''){
      this.notFoundKeyword = '';
      this.searchChange.emit('');
    }

    // Only trigger if length >= 4
    if (value && value.length >= 4) {
      this.debounceTimeout = setTimeout(() => {
        this.notFoundKeyword = value;
        this.searchChange.emit(value);
      }, 1000); // you can keep 1000ms if you want slower debounce
    }
  }

  onZipCodeChange(event: any) {
    // Clear the previous timeout if the user types within the debounce time
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    // Set a new timeout to call the search function after 1000ms
    this.debounceTimeout = setTimeout(() => {
      this.zipCodeChange.emit(event.target.value);
    }, 1000);

    this.zipCode = event.target.value;
  }
}
